// Copyright 2025-2026 NXGN Management, LLC. All Rights Reserved.
import { Suspense } from 'react'
import { Outlet, useNavigation, useRouteError } from 'react-router-dom'

import { LayoutProvider, useLayout } from './layout-context'
import FullPageLoader from '@/app/shared/components/FullPageLoader'
import PageAppBar from '@/app/shared/components/Layout/Page/AppBar'
import StaticSideNav from './Navigation'
import RootBoundary from './RootBoundary'
import * as Styled from './Styles'

const Layout = (): JSX.Element => {
  const { state } = useNavigation()
  const { isNavCollapsed, setIsNavCollapsed } = useLayout()
  const error = useRouteError()

  return (
    <>
      <PageAppBar isGlobal />
      <Styled.Wrapper>
        <StaticSideNav
          isCollapsed={isNavCollapsed}
          handleCollapse={setIsNavCollapsed}
        />
        <Suspense fallback={<FullPageLoader data-testid="template-loading" />}>
          {state === 'loading' ? (
            <FullPageLoader data-testid="template-loading" />
          ) : error ? (
            <RootBoundary />
          ) : (
            <Outlet />
          )}
        </Suspense>
      </Styled.Wrapper>
    </>
  )
}

export default function LayoutWithProvider() {
  return (
    <LayoutProvider>
      <Layout />
    </LayoutProvider>
  )
}
